<template>
  <div class="addEditItem">
<h1>Add / Edit Item</h1>
          <v-form ref="theForm" v-model="valid">
              <v-text-field
                color="accent"
                v-model="name"
                :rules="nameRules"
                label="Item name"
                required
                hint="This is the title of the item. Keep it short."
              ></v-text-field>
              <v-layout wrap>
                <v-flex lg4 sm6 xs10 class="pa-0" >
                  <v-layout class="priceBox pa-0" column>
                    <v-layout row>

                      <VCurrencyField
                        color="accent"
                        v-model="price"
                        prepend-icon="mdi-blank"
                        hint="How much does one cost?"
                        required
                      ></VCurrencyField>
                      <v-flex xs8>
                        <v-tooltip bottom>
                          <span slot="activator">
                            <v-subheader>Price buyer pays
                              <v-icon :color="$vuetify.theme.primary" class="ml-1" small >{{$vuetify.icons.info}}</v-icon>

                            </v-subheader>
                          </span>
                          <span>This is the price the buyer will see in your store.</span>
                        </v-tooltip>

                      </v-flex>
                    </v-layout>
                    <v-layout row>

                      <v-icon small class="mr-2 ml-2">fa-minus</v-icon>
                      <VCurrencyField
                        color="accent"
                        v-model="cost"
                        hint="How much does it cost you to make one?"
                      ></VCurrencyField>
                      <v-flex xs8>
                        <v-tooltip bottom>
                          <span slot="activator">
                            <v-subheader>Cost to make one
                              <v-icon :color="$vuetify.theme.primary" class="ml-1" small >{{$vuetify.icons.info}}</v-icon>
                            </v-subheader>
                          </span>
                          <span>(optional) This is how much it cost you to make one or buy the item originally.<br />
                                Try to include materials you bought and even your time to make it.<br />
                                No else see this but it is used to compute your profit.</span>
                        </v-tooltip>
                      </v-flex>
                    </v-layout>
                    <hr />
                    <v-layout row>
                      <v-icon small class="mr-2 ml-2">fa-equals</v-icon>
                      <VCurrencyField
                        readonly
                        box
                        color="accent"
                        v-model="profit"
                        hint="Profit is how much money you make when you sell one."
                      ></VCurrencyField>
                      <v-flex xs8>
                        <v-tooltip bottom>
                          <span slot="activator">
                            <v-subheader>Profit
                              <v-icon :color="$vuetify.theme.primary" class="ml-1" small >{{$vuetify.icons.info}}</v-icon>
                            </v-subheader>
                          </span>
                          <span>Profit is the amount of money you make when you sell an item.<br />
                                Profit is computed by subtracting the costs to get the item to <br />
                                the buyer from the cost the buyer pays.<br />
                                Profit on this screen only includes the costs to make the item, <br />
                                but other costs can reduce your profit also like "free shipping".
                                </span>
                        </v-tooltip>

                      </v-flex>
                    </v-layout>
                  </v-layout>
                </v-flex>
                &nbsp;
                <v-flex lg4 sm5 xs10>
                  <v-layout row>

                    <v-text-field
                      color="accent"
                      type=number
                      v-model.number="quantity"
                      :rules="quantityRules"
                      mask="#####"
                      hint="How many do you have to sell?"
                      required
                    ></v-text-field>
                    <v-flex xs8>
                      <v-tooltip bottom>
                        <span slot="activator">
                          <v-subheader>Quantity
                            <v-icon :color="$vuetify.theme.primary" class="ml-1" small >{{$vuetify.icons.info}}</v-icon>
                          </v-subheader>
                        </span>
                        <span>This is the number of this item you have to sell.<br />
                              As you sell them the system will subtract from this number and<br />
                              if it gets to 0 items, then the item will be marked "Sold Out" automatically
                              </span>
                      </v-tooltip>
                    </v-flex>
                  </v-layout>
                </v-flex>
                &nbsp;

              </v-layout>
              <br />
              <div class="text-xs-left">
                Item Description
              </div>
              <v-flex sm11 xs12>
                <vue-editor color="accent" v-model="description" required :editorToolbar="customToolbar"></vue-editor>
              </v-flex>
              <br />
              <ItemDimensions v-model="dimensions"></ItemDimensions>
            </v-form>
            <v-container>
                <v-layout align-center justify-center row fill-height wrap >
                    <v-flex class="sm4 xs12 pa-1"><Thumbnail ref="thumb0" :origImg="thumbnails[0]" ></Thumbnail></v-flex>
                    <v-flex class="sm4 xs12 "><Thumbnail ref="thumb1" :origImg="thumbnails[1]" ></Thumbnail></v-flex>
                    <v-flex class="sm4 xs12  pa-1"><Thumbnail ref="thumb2" :origImg="thumbnails[2]" ></Thumbnail></v-flex>
                </v-layout>
            </v-container>
            <br />
          <v-flex>
              <v-btn :disabled="!valid" @click="save" class="accent">SAVE</v-btn>
              <v-btn @click="$router.go(-1)">CANCEL</v-btn>
          </v-flex>
          <v-flex v-if="errorText != null" class="error--text">
            {{errorText}}
          </v-flex>
          <v-spacer></v-spacer>
          <v-dialog
            v-model="loadingDialog"
            hide-overlay
            persistent
            width="300"
          >
            <v-card
              color="success"
              dark
            >
              <v-card-text>
                Saving...
                <v-progress-linear
                  :value="savingProgress"
                  color="white"
                  class="mb-0"
                ></v-progress-linear>
              </v-card-text>
            </v-card>
          </v-dialog>

</div>

</template>

<script>
import {mapState} from 'vuex'
import VCurrencyField from './VCurrencyField.vue'
import Thumbnail from './Thumbnail.vue'
import ItemDimensions from './ItemDimensions.vue'
import {VueEditor} from 'vue2-editor' // https://github.com/davidroyer/vue2-editor

import utils from '../../utils.ts'
const uuidv1 = require('uuid/v1')

export default {
  name: 'AddEditItem',
  components: {
    VCurrencyField,
    Thumbnail,
    ItemDimensions,
    VueEditor
  },
  props: {
  },
  data () {
    return {
      errorText: null,
      dimensions: {},
      loadingDialog: false,
      savingProgress: 0,
      valid: false,
      itemID: '',
      name: '',
      quantity: 0,
      description: '',
      price: 0,
      cost: 0,
      categoryID: null,
      thumbnails: [null, null, null],
      nameRules: [
        v => !!v || 'Item name is required'
      ],
      quantityRules: [
        v => v >= 0 || 'Quantity cannot be less than 0 ' + v
      ],
      customToolbar: [
        ['bold', 'italic', 'underline'],
        [{'header': 1}, {'header': 2}],
        [{list: 'ordered'}, {list: 'bullet'}],
        [{'color': []}, {'background': []}]
      ]
    }
  },
  computed: {
    ...mapState({
      locked: (state) => state.admin.public_settings.locked,
    }),
    profit: {
      set: function (val) { },
      get: function () {
        if (this.price !== undefined && this.cost !== undefined) {
          return this.price - this.cost
        } else {
          return this.price
        }
      }
    }
  },
  mounted: function () {
    if (this.$route.params.name) {
      const p = this.$route.params
      this.itemID = p.id
      this.name = p.name
      this.cost = p.cost
      this.quantity = p.quantity
      this.description = p.description
      this.price = p.price
      this.categoryID = p.category
      this.thumbnails = Object.assign([], p.thumbnails)
      this.dimensions = p.dimensions
    }
  },
  methods: {
    categoryChanged: function (newCategory) {
      this.categoryID = newCategory
    },
    processThumbnailChanges: async function (thumbRef, thumbIndex) {
      // Delete any thumbnails which need to be deleted
      // And add the current one into the data
      const thumb = this.$refs[thumbRef]

      // Get images to remove
      const fileChanged = thumb.wasFileChanged()

      // If the file was changed, remove the old file
      if (fileChanged) {
        const pic = this.thumbnails[thumbIndex]

        // Remove it from Storage if it existed
        if (pic) {
          try {
            await utils.removeFile(pic.imgPath, pic.fileName)
          } catch (err) {
            console.error(err)
          }
          this.savingProgress += 5

          try {
            await utils.removeFile(pic.imgPath, pic.thumbFileName)
          } catch (err) {
            console.log(err)
          }

          this.savingProgress += 5
        }

        // Now handle the upload of the new file (or it could be removed)
        const currentPic = thumb.getCurrentPic()
        this.savingProgress += 5

        // console.log('THUMB VAL:' + JSON.stringify(thumb.getCurrentPic()))

        if (currentPic) {
          const imgData = currentPic.imgBlob
          const fileName = currentPic.fileName
          const imgPath = [this.uid, 'image', uuidv1()].join('/')
          const thumbFileName = 'thumb_' + fileName

          // We have a new pic to upload to storage
          let downloadURL
          if (imgData instanceof Blob) {
            downloadURL = utils.uploadImgBlob(imgData, imgPath, fileName) // This is a promise
          } else {
            downloadURL = utils.uploadBase64Img(imgData, imgPath, fileName) // This is a promise
          }

          console.log("2Waiting for promises....")
          await downloadURL

          const smallImg = utils.thumbnailify(imgData, 100, true)
          const thumbDownloadURL = smallImg.then((thumbBase64img) => {
            return utils.uploadBase64Img(thumbBase64img, imgPath, thumbFileName) // This is a promise also
          })

          console.log("1Waiting for promises....")
          await thumbDownloadURL

          console.log("3Waiting for promises....")

          const urls = await Promise.all([downloadURL, thumbDownloadURL])

          this.savingProgress += 20

          delete currentPic.imgBlob // Remove it so we do not store it!
          currentPic.downloadURL = urls[0]
          currentPic.thumbDownloadURL = urls[1]
          currentPic.imgPath = imgPath
          currentPic.thumbFileName = thumbFileName
          this.thumbnails[thumbIndex] = currentPic
        } else {
          // Img was removed
          this.thumbnails[thumbIndex] = null
        }
      } else {
        this.savingProgress += 30
      }
    },
    save: async function (event) {

      this.errorText = null
      try {
        if (this.locked) {
          throw new Error("Demo account is locked. Cannot edit items.")
        }
        this.savingProgress = 0
        this.loadingDialog = true

        // Handle the thumbnails
        await this.processThumbnailChanges('thumb0', 0)
        await this.processThumbnailChanges('thumb1', 1)
        await this.processThumbnailChanges('thumb2', 2)

        this.savingProgress = 90
        const itemData = {
          name: this.name,
          category: this.categoryID,
          quantity: this.quantity,
          description: this.description,
          price: this.price,
          cost: this.cost,
          thumbnails: this.thumbnails,
          dimensions: this.dimensions
        }
        console.log('AddEditItem itemData: ' + JSON.stringify(itemData))

        this.$store.dispatch('admin/addEditItem',
          {
            iid: this.itemID,
            itemData: itemData
          }).then(() => {
          this.$router.go(-1)
        })
      } catch (err) {
        this.errorText = err.message
      }

      this.loadingDialog = false
    }

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.addEditItem {
  width: 100%;
  margin: 10px;
}
.thumbnail {
    width: 25%;
    height: 25%;
}

.priceBox {
  border: solid gray 1px;
}

</style>
